module.exports = __webpack_public_path__ + "static/projekt_indywidualny_c01-3516c885649d0cfbdcbee4271c20d3f8.jpg";